import create from 'zustand'

export interface Student {
  amount: number;
  revenue: number;
  amountMask: string;
  course: string;
  firebaseId: string;
  id: string;
  name: string;
  status: string;
  createdAt: Date;
  outdatedContract: boolean;
}

export const useStudents = create<Student[]>(() => ([]))
